import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useLazyQuery } from '@apollo/client';
import { Card, CardContent } from '@guildeducationinc/recess';
// import DeleteOutlineIcon from '@guildeducationinc/recess/icons/DeleteOutlineIcon';
import EditIcon from '@guildeducationinc/recess/icons/EditIcon';
import { AdminTopNav } from '@src/components/Admin/AdminTopNav/AdminTopNav';
import { PopulationBuilder } from '@src/components/Admin/PolicyBuilder/PopulationBuilder';
import { TEST_POPULATION_COVERAGE } from '@src/graphql/queries/filter';
import { useClientIdParam } from '@src/hooks/useClientIdParam';
import { EntityType } from '@src/types';
import { getPolicyNavLinks } from '@src/utilities/topNavHelper';
import { DataTable, TrackableButton, emptyFilter, useFilters, useLocale, } from 'pe-core-frontend';
import { useEffect, useState } from 'react';
export const Populations = () => {
    const clientId = useClientIdParam() || 0;
    const { t } = useLocale();
    const { items, loading } = useFilters({
        clientId,
        returnType: EntityType.EMPLOYEE,
    });
    const [testResult, setTestResult] = useState(null);
    const [testCoverageQuery, testCoverageResult] = useLazyQuery(TEST_POPULATION_COVERAGE);
    useEffect(() => {
        if (testCoverageResult?.data) {
            setTestResult({
                found: testCoverageResult.data.testPopulationCoverage.found,
                total: testCoverageResult.data.testPopulationCoverage.total,
            });
        }
        if (testCoverageResult?.error) {
            setTestResult({
                error: testCoverageResult.error.message,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [testCoverageResult]);
    const [selectedFilter, setSelectedFilter] = useState(undefined);
    const handleOpenPopulation = (filter) => {
        setSelectedFilter(filter ?? { ...emptyFilter, clientId, returnType: EntityType.EMPLOYEE });
    };
    const handleOnCompleted = () => {
        setSelectedFilter(undefined);
    };
    // const handleDeletePopulation = (filter: Filter) => {
    //   console.log('handleDeleteFilter', filter);
    // };
    const handleTestCoverage = async () => {
        await testCoverageQuery({
            variables: {
                clientId,
            },
        });
    };
    return (_jsxs("div", { children: [_jsx(AdminTopNav, { title: t('Policy'), navLinks: getPolicyNavLinks(t, clientId, 'populations'), actions: _jsxs("div", { className: 'flex gap-2', children: [_jsx(TrackableButton, { btnType: 'mui', enText: 'Test Coverage', tag: 'header', color: 'secondary', variant: 'outlined', onClick: () => handleTestCoverage(), children: t('Test Coverage') }), _jsx(TrackableButton, { btnType: 'mui', enText: 'Add Population', tag: 'header', variant: 'contained', onClick: () => handleOpenPopulation(), children: t('Add Population') })] }) }), _jsx("div", { children: (selectedFilter && clientId && (_jsx(Card, { children: _jsx(CardContent, { children: _jsx(PopulationBuilder, { clientId: clientId, value: selectedFilter, onCompleted: () => handleOnCompleted() }) }) }))) || (_jsxs(_Fragment, { children: [_jsx("div", { className: 'flex mb-1', children: _jsx("div", { className: 'grow text-right', children: testResult && (_jsxs("span", { className: 'font-bold mr-1', children: [!testResult.error && (_jsx("span", { children: t('Populations cover {found} out of {total} total employees', {
                                                values: { found: testResult.found, total: testResult.total },
                                            }) })), testResult.error && (_jsx("span", { className: 'text-red-600', children: t('Error running test') }))] })) }) }), _jsx(DataTable, { loading: loading, disableColumnMenu: true, disableRowSelectionOnClick: true, rows: items || [], hideFooter: true, columns: [
                                {
                                    field: 'name',
                                    headerName: t('Name'),
                                    flex: 0.2,
                                    sortable: false,
                                },
                                {
                                    field: 'action',
                                    headerName: t('Actions'),
                                    renderCell: ({ row }) => (_jsx("div", { children: _jsx(TrackableButton, { btnType: 'icon', enText: 'Edit', tag: `population_${row.id}`, label: t('Edit'), appearance: 'minimal', icon: _jsx(EditIcon, { size: 20 }), className: 'margin--right_8', onClick: () => handleOpenPopulation(row) }) })),
                                    width: 100,
                                    sortable: false,
                                },
                            ] })] })) })] }));
};
